import { MaxBrainAudience } from 'app/library/audience/models/audience.model';
import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { Posting } from 'app/library/posting/models/posting.model';
import { IHeaderBannerContentPreviewQuery } from '../interfaces/header-banner-conent-preview.query.interface';

// @dynamic
export class HeaderBannerContentPreview {
    title: string;
    description: string;
    image: MaxbrainImage;
    carouselView: boolean;
    maxVisibleLength: number;
    widgetId: string;
    widgetName: string;
    content: {
        id: string;
        audience: MaxBrainAudience;
        posting: Posting;
        featuredStream: {};
        priority: string;
        startDate: string;
        endDate: string;
    }[];

    constructor(query?: IHeaderBannerContentPreviewQuery) {
        if (query) {
            this.title = query.title;
            this.description = query.description;
            this.image = new MaxbrainImage(query.image);
            this.carouselView = query.carousel_view;
            this.maxVisibleLength = query.max_visible_length;
            this.widgetId = query.widget_id.toString();
            this.widgetName = query.widget_name;
            this.content = query.content.map((content) => {
                return {
                    id: content.id.toString(),
                    audience: new MaxBrainAudience(content.audience),
                    posting: new Posting(content.posting),
                    featuredStream: content.featured_stream,
                    priority: content.priority,
                    startDate: content.start_date,
                    endDate: content.end_date,
                };
            });
        }
    }
}
